let index = {
  centerlevel: "/management/qss/game/centerlevel",
  tranpay: "/management/qss/game/tranpay",
  search: "/management/qss/search",
  gamebase: "/management/qss/setup/gamebase",
  addressbase: "/management/qss/setup/addressbase",
  updatepwd: "/management/qss/updatepwd",
  tranpay_2022: "/management/qss/game/2022tranpay",
  record: "/management/qss/game/record"
};
export default [
  /**中央本级 */
  {
    path: "qss/game/centerlevel",
    component: () => import(/* webpackChunkName: "qss_centerlevel" */ "@/views/qss/approval/centerlevel/Main.vue"),
    meta: { index: index.centerlevel },
    children: [
      {
        path: "",
        name: "qss_centerlevel_list",
        component: () =>
          import(/* webpackChunkName: "qss_centerlevel_list" */ "@/views/qss/approval/centerlevel/Index.vue"),
        meta: { index: index.centerlevel }
      },
      {
        path: ":id",
        name: "qss_centerlevel_list_editGame",
        component: () => import(/* webpackChunkName: "editGame" */ "@/views/sportcenter/management/game/EditGame.vue"),
        meta: { index: index.centerlevel }
      },
      {
        path: ":id",
        name: "qss_centerlevel_list_editTrainCamp",
        component: () =>
          import(/* webpackChunkName: "editTrainCamp" */ "@/views/sportcenter/management/traincamp/EditTrainCamp.vue"),
        meta: { index: index.centerlevel }
      },
      {
        path: ":id",
        name: "qss_centerlevel_list_editCampusSchool",
        component: () =>
          import(/* webpackChunkName: "editSchool" */ "@/views/sportcenter/management/campus/EditSchool.vue"),
        meta: { index: index.centerlevel }
      },
      {
        path: ":id",
        name: "qss_centerlevel_list_editClub",
        component: () => import(/* webpackChunkName: "editClub" */ "@/views/sportcenter/management/club/EditClub.vue"),
        meta: { index: index.centerlevel }
      }
    ]
  },
  /**转移支付 */
  {
    path: "qss/game/tranpay",
    component: () => import(/* webpackChunkName: "qss_tranpay" */ "@/views/qss/approval/tranpay/Main.vue"),
    meta: { index: index.tranpay },
    children: [
      {
        path: "",
        name: "qss_tranpay_list",
        component: () => import(/* webpackChunkName: "qss_tranpay_list" */ "@/views/qss/approval/tranpay/Index.vue"),
        meta: { index: index.tranpay }
      },
      {
        path: ":id",
        name: "qss_tranpay_list_editActivities",
        component: () =>
          import(
            /* webpackChunkName: "qss_editActivities" */ "@/views/province/management/activities/EditActivities.vue"
          ),
        meta: { index: index.tranpay }
      },
      {
        path: ":id",
        name: "qss_tranpay_list_editClass",
        component: () =>
          import(/* webpackChunkName: "qss_editClass" */ "@/views/province/management/coache/EditClass.vue"),
        meta: { index: index.tranpay }
      },
      {
        path: ":id",
        name: "qss_tranpay_list_editBase",
        component: () =>
          import(/* webpackChunkName: "qss_editBase" */ "@/views/province/management/reserve/EditBase.vue"),
        meta: { index: index.tranpay }
      },
      {
        path: ":id",
        name: "qss_tranpay_list_editYouth",
        component: () =>
          import(/* webpackChunkName: "qss_editYouth" */ "@/views/province/management/youthTraining/editYouth.vue"),
        meta: { index: index.tranpay }
      },
      {
        path: ":id",
        name: "qss_tranpay_list_editSchool",
        component: () =>
          import(/* webpackChunkName: "qss_editSchool" */ "@/views/province/management/school/editSchool.vue"),
        meta: { index: index.tranpay }
      },
      {
        path: ":id",
        name: "qss_tranpay_list_editFootBall",
        component: () =>
          import(/* webpackChunkName: "qss_editFootBall" */ "@/views/province/management/football/EditFootBall.vue"),
        meta: { index: index.tranpay }
      },
      {
        path: ":id",
        name: "qss_tranpay_list_editSupportOlympics",
        component: () =>
          import(
            /* webpackChunkName: "qss_editSupportOlympics" */ "@/views/province/management/supportOlympics/editSupportOlympics.vue"
          ),
        meta: { index: index.tranpay }
      },
      {
        path: ":id",
        name: "qss_tranpay_list_editImportantProjects",
        component: () =>
          import(
            /* webpackChunkName: "qss_editImportantProjects" */ "@/views/province/management/importantProjects/editImportantProjects.vue"
          ),
        meta: { index: index.tranpay }
      }
    ]
  },
  /**2022年转移支付(提前下达部分) */
  {
    path: "qss/game/2022tranpay",
    component: () => import(/* webpackChunkName: "admin_tranpay" */ "@/views/qss/approval/2022tranpay/Main.vue"),
    meta: { index: index.tranpay_2022 },
    children: [
      {
        path: "",
        name: "qss_2022tranpay_list",
        component: () =>
          import(/* webpackChunkName: "admin_tranpay_list" */ "@/views/qss/approval/2022tranpay/Index.vue"),
        meta: { index: index.tranpay_2022 }
      },
      {
        path: ":id",
        name: "qss_2022tranpay_list_editActivities",
        component: () =>
          import(
            /* webpackChunkName: "admin_editActivities" */ "@/views/province/management/tranpay/EditActivities.vue"
          ),
        meta: { index: index.tranpay_2022 }
      },
      {
        path: "new",
        name: "qss_2022tranpay_list_addActivities",
        component: () =>
          import(
            /* webpackChunkName: "admin_editActivities" */ "@/views/province/management/tranpay/EditActivities.vue"
          ),
        meta: { index: index.tranpay_2022 }
      }
    ]
  },
  /**全国青少年体育赛事备案 */
  {
    path: "qss/game/record",
    component: () =>
      import(/* webpackChunkName: "sportcenter_record" */ "@/views/sportcenter/management/record/Main.vue"),
    meta: { index: index.record },
    children: [
      {
        path: "",
        name: "qss_record_list",
        component: () =>
          import(/* webpackChunkName: "qss_record_list" */ "@/views/sportcenter/management/record/Index.vue"),
        meta: { index: index.record }
      },
      {
        path: ":id",
        name: "qss_record_list_editrecord",
        component: () =>
          import(/* webpackChunkName: "editRecord" */ "@/views/sportcenter/management/record/EditRecord.vue"),
        meta: { index: index.record }
      },
      {
        path: "new",
        name: "qss_record_list_addrecord",
        component: () =>
          import(/* webpackChunkName: "editRecord" */ "@/views/sportcenter/management/record/EditRecord.vue"),
        meta: { index: index.record }
      }
    ]
  },
  /**综合查询 */
  {
    path: "qss/search",
    component: () => import(/* webpackChunkName: "qss_search" */ "@/views/qss/search/Main.vue"),
    meta: { index: index.search },
    children: [
      {
        path: "",
        name: "qss_search_list",
        component: () => import(/* webpackChunkName: "qss_search_list" */ "@/views/qss/search/Index.vue"),
        meta: { index: index.search }
      },
      {
        path: ":id",
        name: "qss_search_list_editGame",
        component: () => import(/* webpackChunkName: "editGame" */ "@/views/sportcenter/management/game/EditGame.vue"),
        meta: { index: index.search }
      },
      {
        path: ":id",
        name: "qss_search_list_editTrainCamp",
        component: () =>
          import(/* webpackChunkName: "editTrainCamp" */ "@/views/sportcenter/management/traincamp/EditTrainCamp.vue"),
        meta: { index: index.search }
      },
      {
        path: ":id",
        name: "qss_search_list_editCampusSchool",
        component: () =>
          import(/* webpackChunkName: "editSchool" */ "@/views/sportcenter/management/campus/EditSchool.vue"),
        meta: { index: index.search }
      },
      {
        path: ":id",
        name: "qss_search_list_editClub",
        component: () => import(/* webpackChunkName: "editClub" */ "@/views/sportcenter/management/club/EditClub.vue"),
        meta: { index: index.search }
      },
      {
        path: ":id",
        name: "qss_search_list_editClass",
        component: () =>
          import(/* webpackChunkName: "qss_editClass" */ "@/views/province/management/coache/EditClass.vue"),
        meta: { index: index.search }
      },
      {
        path: ":id",
        name: "qss_search_list_editBase",
        component: () =>
          import(/* webpackChunkName: "qss_editBase" */ "@/views/province/management/reserve/EditBase.vue"),
        meta: { index: index.search }
      },
      {
        path: ":id",
        name: "qss_search_list_editYouth",
        component: () =>
          import(/* webpackChunkName: "qss_editYouth" */ "@/views/province/management/youthTraining/editYouth.vue"),
        meta: { index: index.tranpay }
      },
      {
        path: ":id",
        name: "qss_search_list_editSchool",
        component: () =>
          import(/* webpackChunkName: "admin_qss" */ "@/views/province/management/school/editSchool.vue"),
        meta: { index: index.search }
      }
      // {
      //   path: ":id",
      //   name: "qss_search_list_editFootBall",
      //   component: () =>
      //     import(/* webpackChunkName: "qss_editFootBall" */ "@/views/province/management/football/EditFootBall.vue"),
      //   meta: { index: index.search }
      // }
    ]
  },
  /**赛事名录 */
  {
    path: "qss/setup/gamebase",
    component: () => import(/* webpackChunkName: "qss_gamebase" */ "@/views/qss/other/gamebase/Main.vue"),
    meta: { index: index.gamebase },
    children: [
      {
        path: "",
        name: "qss_gamebase_list",
        component: () => import(/* webpackChunkName: "qss_gamebase_list" */ "@/views/qss/other/gamebase/Index.vue"),
        meta: { index: index.gamebase }
      }
    ]
  },
  /**人才培养基地 */
  {
    path: "qss/setup/addressbase",
    component: () => import(/* webpackChunkName: "qss_addressbase" */ "@/views/qss/other/addressbase/Main.vue"),
    meta: { index: index.addressbase },
    children: [
      {
        path: "",
        name: "qss_addressbase_list",
        component: () =>
          import(/* webpackChunkName: "qss_addressbase_list" */ "@/views/qss/other/addressbase/Index.vue"),
        meta: { index: index.addressbase }
      }
    ]
  },
  /**修改密码 */
  {
    path: "qss/updatepwd",
    component: () => import(/* webpackChunkName: "qss_updatepwd" */ "@/views/setting/password/Update.vue"),
    meta: { index: index.updatepwd },
    children: [
      {
        path: "",
        name: "qss_updatepwd_list",
        component: () => import(/* webpackChunkName: "qss_updatepwd_list" */ "@/views/setting/password/Update.vue"),
        meta: { index: index.updatepwd }
      }
    ]
  }
];
